export function shouldShowChatPopup(key = 'chat_popup_last_shown', hours = 12) {
  const lastShown = localStorage.getItem(key);
  const now = Date.now();
  const gap = hours * 60 * 60 * 1000;

  if (!lastShown || now - parseInt(lastShown) > gap) {
    localStorage.setItem(key, now.toString());
    return true;
  }
  return false;
}
